/* Program Name: Alerts.js
 **  Description: Pop up alerts for user feedback. state is controled in the
 **               AlertProvider component
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 ****************************************&*****************************************/

/**React Hook import */
import React from 'react'

/**Material UI imports */
import { Snackbar, Alert } from '@mui/material' //DOCS: https://material-ui.com/components/snackbars/

/** Alerts
 *
 * @param {object}   alert             - and object that contains information on the status and type of alert to toggle
 * @param {fucntion} close             - a function that closes all alerts
 * @param {String}   message           - holds a message for the error alerts if there is a message to display
 */
export default function Alerts({ alert, message, close }) {
  /******************************************************************************/
  /**State Variables*/

  //style for the alerts
  const style = {
    width: '50vw',
  }

  /******************************************************************************/
  /**Split Message*/
  /******************************************************************************/
  /** returns the message split into lines for the alert
   *  * @param {string} message - the message that is to be displayed in the alert
   */
  const splitMessage = (message) => {
    return message.split('\n')
  }

  /*****************************************************************************/
  /**Rendering */

  return (
    <>
      <Snackbar
        open={alert.success}
        autoHideDuration={500}
        onClose={close}
        style={{ marginTop: '64px' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          style={style}
          elevation={6}
          variant="filled"
          onClose={close}
          severity="success"
        >
          Success!{' '}
          <span>
            {message &&
              splitMessage(message).map((line) => {
                return <div key={line}>{line}</div>
              })}
          </span>
        </Alert>
      </Snackbar>
      <Snackbar
        open={alert.warning}
        onClose={close}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          style={{ width: '50vw', color: '#222222' }}
          elevation={6}
          variant="filled"
          onClose={close}
          severity="warning"
        >
          Warning:{' '}
          {message &&
            splitMessage(message).map((line) => {
              return <div key={line}>{line}</div>
            })}
        </Alert>
      </Snackbar>
      <Snackbar
        style={{ marginTop: '64px' }}
        open={alert.error}
        onClose={close}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          style={style}
          elevation={6}
          variant="filled"
          onClose={close}
          severity="error"
        >
          Error:{' '}
          <span style={{ fontSize: '16px' }}>
            {message &&
              splitMessage(message).map((line, i) => {
                return (
                  <div
                    style={{
                      fontSize:
                        i === splitMessage(message).length - 1 ? '12px' : null,
                    }}
                    key={line}
                  >
                    {line}
                  </div>
                )
              })}
          </span>
        </Alert>
      </Snackbar>
    </>
  )
}
